// removed by extract-text-webpack-plugin
module.exports = {"block":"CatalogTabs__block-TRIpX","tabs":"CatalogTabs__tabs-3uAmG","tab":"CatalogTabs__tab-2auS3"};